/** Dispatched on `document` by a full screen the open navigation would paint over. */
export const CLOSE_NAVIGATION_EVENT = "close.restaumatic.navigation";
const defaultOptions = {
    activeClassName: "active",
    dropdownSelector: ".dropdown",
    dropdownToggleSelector: ".dropdown-toggle",
};
/**
 * Mark active navigation links.
 */
function markActiveNavLinks(navigation, pathname, options) {
    navigation.querySelectorAll(`[href="${pathname}"]`).forEach((item) => {
        const dropdown = item.closest(options.dropdownSelector);
        const dropdownToggle = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector(options.dropdownToggleSelector);
        item.classList.add(options.activeClassName);
        dropdownToggle === null || dropdownToggle === void 0 ? void 0 : dropdownToggle.classList.add(options.activeClassName);
    });
}
/**
 * Get navigation position.
 *
 * @param nav Navigation element.
 * @returns Navigation position (left, right or fullwidth).
 */
function getNavigationMode(nav) {
    const box = nav.getBoundingClientRect();
    const distanceLeft = Math.round(box.left - document.body.scrollLeft);
    const distanceRight = Math.round(window.innerWidth - distanceLeft - box.width);
    if (distanceLeft <= 0 && distanceRight > 0) {
        return "left";
    }
    else if (distanceLeft > 0 && distanceRight <= 0) {
        return "right";
    }
    return "fullwidth";
}
/**
 * Close the navigation with swipe gestures within the navigation and its background.
 */
function swipeToClose(nav, close) {
    const backdrop = document.querySelector(".mobile-navigation-backdrop");
    const elements = [nav, backdrop];
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoveEndX = 0;
    let touchMoveEndY = 0;
    let isClosing = false;
    elements.forEach((el) => {
        el.addEventListener("touchstart", 
        // @ts-expect-error Problem with TouchEvent compatibility with EventListener type
        (e) => {
            isClosing = false;
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
        }, {
            passive: true,
        });
        el.addEventListener("touchmove", 
        // @ts-expect-error Problem with TouchEvent compatibility with EventListener type
        (e) => {
            touchMoveEndX = e.touches[0].clientX;
            touchMoveEndY = e.touches[0].clientY;
            const threshold = 20; // prevent accidental closing with gentle gestures
            const xDiff = touchStartX - touchMoveEndX;
            const yDiff = touchStartY - touchMoveEndY;
            if (Math.abs(xDiff) > Math.abs(yDiff) && Math.abs(xDiff) >= threshold) {
                // horizontal swipe
                const navigationPosition = getNavigationMode(nav);
                if (xDiff > 0 && navigationPosition === "left") {
                    // left swipe and left navigation
                    if (!isClosing) {
                        close();
                    }
                    isClosing = true;
                }
                else if (xDiff < 0 && navigationPosition === "right") {
                    // right swipe and right nawigation
                    if (!isClosing) {
                        close();
                    }
                    isClosing = true;
                }
            }
        }, {
            passive: true,
        });
    });
}
function init(selector = ".js-navigation") {
    const navs = document.querySelectorAll(selector);
    if (navs.length === 0) {
        return;
    }
    const responsiveNav = document.getElementById("responsive-nav");
    const navToggles = document.querySelectorAll(".js-navigation-toggle");
    const pathname = location.pathname;
    let open = false;
    const applyOpenState = () => {
        if (open) {
            navToggles.forEach((toggle) => toggle.classList.add("is-active"));
            responsiveNav === null || responsiveNav === void 0 ? void 0 : responsiveNav.classList.add("is-open");
            responsiveNav === null || responsiveNav === void 0 ? void 0 : responsiveNav.setAttribute("aria-expanded", "true");
            document.body.classList.add("l-navigation-open");
        }
        else {
            navToggles.forEach((toggle) => toggle.classList.remove("is-active"));
            responsiveNav === null || responsiveNav === void 0 ? void 0 : responsiveNav.classList.remove("is-open");
            responsiveNav === null || responsiveNav === void 0 ? void 0 : responsiveNav.setAttribute("aria-expanded", "false");
            document.body.classList.remove("l-navigation-open");
        }
    };
    const close = () => {
        if (!open) {
            return;
        }
        open = false;
        applyOpenState();
    };
    const toggle = () => {
        open = !open;
        applyOpenState();
    };
    navs.forEach((item) => {
        const nav = item;
        const options = Object.assign({}, defaultOptions, nav.dataset.navigation ? JSON.parse(nav.dataset.navigation) : null);
        markActiveNavLinks(nav, pathname, options);
        if (nav.classList.contains("mobile-navigation")) {
            swipeToClose(nav, close);
        }
    });
    navToggles.forEach((navToggle) => {
        navToggle.addEventListener("click", (e) => {
            toggle();
            e.preventDefault();
        });
    });
    document.addEventListener("to-element.restaumatic.scroll", close);
    document.addEventListener(CLOSE_NAVIGATION_EVENT, close);
}
export default {
    init,
};
